import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';

import { selectActiveVenue, selectMsInventoryVenues } from 'selectors/general';
import { syncValidator as validate } from './InstructorFormValidator';
import InstructorForm from './InstructorForm';
import {
  saveInstructor as saveInstructorAction,
  cancelInstructorForm as cancelInstructorFormAction,
} from '../Instructors.saga';

const defaultSocialHandle = [{ service: 'instagram', userName: '' }];

export const mapStateToProps = (state, ownProps) => {
  const { instructorId, instructor = {}, ...restOwnProps } = ownProps;
  const { venueId, countryCodeShort } = selectActiveVenue(state);
  const venues = selectMsInventoryVenues(state);

  return {
    instructor,
    initialValues: {
      socialHandles: defaultSocialHandle,
      venueIds: venues.filter(venue => venue.current).map(venue => venue.id),
      ...instructor,
    },
    venues,
    venueId,
    countryCodeShort,
    ...restOwnProps,
  };
};

const mapDispatchToProps = {
  saveInstructor: saveInstructorAction,
  cancelInstructorForm: cancelInstructorFormAction,
};

export const mergeProps = (stateProps, dispatchProps) => {
  const {
    instructor: { id: instructorId },
  } = stateProps;
  const { saveInstructor, cancelInstructorForm } = dispatchProps;

  return {
    onSubmit: saveInstructor.bind(null, instructorId),
    onCancel: cancelInstructorForm,
    ...stateProps,
    ...dispatchProps,
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  reduxForm({
    form: 'INSTRUCTOR_FORM',
    validate,
    enableReinitialize: true,
  })
)(InstructorForm);
